import Link from 'next/link';
import classes from './TextCard.module.scss';
import { Button, Container } from '@mantine/core';
import { Title } from '../../Title/Title';

type TextCardProps = {
  title: string;
  description: string;
  button?: string;
  buttonColor?: string;
  buttonHref?: string;
};

export const TextCard = ({ data }: { data: TextCardProps }) => {
  const { title, description, button, buttonColor, buttonHref } = data;

  return (
    <div>
      <Container>
        <section className={classes.horizontalSection}>
          <Title title={title} />
          <p>{description}</p>
          {button && (
            <Button className={classes.button} component={Link} href={buttonHref ?? ''}>
              {button}
            </Button>
          )}
        </section>
      </Container>
    </div>
  );
};
